import axios from 'axios';
import * as yup from 'yup';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup.object()
});
export async function getPatientById({ patientId, }) {
    const response = await axios.post('/api/tasks/getPatientById', {
        patient_id: patientId,
    });
    const { data } = await responseSchema.validate(response.data);
    return {
        data,
    };
}
